<header class="ash">
  <div class="ash-left">
    <button type="button" class="ash-brand" (click)="goHome()">
      Angularize<span class="ash-beta">Beta</span>
    </button>
    <span class="ash-sep" *ngIf="crumb">/</span>
    <span class="ash-crumb" *ngIf="crumb">{{ crumb }}</span>
  </div>

  <div class="ash-right">
    <app-user-menu *ngIf="user" [user]="user"></app-user-menu>
  </div>
</header>